import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"

import Components from "../../components"
import Button from "../button"

import remarkReactComponents from "../../helpers/remarkReactComponents"

const Academic = ({ blok }) => (
  <SbEditable content={blok}>
    <div className="academic">
      {blok.academic_cta &&
        blok.academic_cta.map((content) => (
          <Button
            key={content._uid}
            blok={content}
            className="academic__btn btn--cta"
          />
        ))}
      {blok.academic_image &&
        blok.academic_image.map((content) =>
          React.createElement(Components(content.component), {
            key: content._uid,
            blok: content,
            className: "academic__image",
          })
        )}
      <div className="academic__card card card--pd-sm">
        <h3 className="academic__heading">{blok.title}</h3>
        {
          unified()
            .use(remarkParse)
            .use(remarkRehype)
            .use(rehypeReact, {
              createElement: React.createElement,
              components: remarkReactComponents,
              Fragment: React.Fragment,
            })
            .processSync(blok.copy).result
        }
      </div>
    </div>
  </SbEditable>
)

Academic.propTypes = {
  blok: PropTypes.shape({
    academic_image: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    copy: PropTypes.string,
    academic_cta: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default Academic
